import React = require('react');
import { useState } from 'react';

export const GadgetMoreInfo = ({ deprecation }) => {

  const [showMoreInfo, setShowMoreInfo] = useState(false);

  const changeShowMoreInfo = () => {
    setShowMoreInfo(!showMoreInfo)
  }

  return (
    <>
      <div>
        Refurbished gadgets must be bought directly from the manufacturer or a reputable retailer. For second hand
        items, you must be able to provide proof of purchase such as a printed or digital receipt.<span
        className={'more-info'}
        onClick={changeShowMoreInfo}>{showMoreInfo ? ' Less information' : ' More information'}</span>
      </div>
      {showMoreInfo && (
        <>
          <div className={'more-info-table-header'}><b>Important:</b> Gadgets are subject to wear and tear deductions.
            This doesn’t apply to gadgets less than 12 months old at the time of the incident.
          </div>
          <div className={'more-info-table-row'}>
            <div className={'more-info-table-column'}><b>Item</b></div>
            <div className={'more-info-table-column'}><b>Depreciation applicable</b></div>
          </div>
          <div className={'more-info-table-row'}>
            <div className={'more-info-table-column'}>Gadget</div>
            <div className={'more-info-table-column'}>
              <div>{deprecation ? deprecation : '20'}% per year up to a maximum depreciation of 60%</div>
              <div style={{ marginTop: '15px' }}>For example, if you bought an item for £200 three years ago, and the
                rate of depreciation is considered to be 10% a year, the deduction would be calculated as 30% (10% x 3
                years) of the original £200.
              </div>
            </div>
          </div>
        </>

      )}
    </>
  )
}
